var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Final-Screens_-DRAFT",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GlidePath_-Starter",
    transform: "translate(-82.000000, -787.000000)",
    fill: "#FA4242",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.5162393,788.502011 C98.5152901,788.50102 98.5143057,788.500064 98.5135323,788.499285 C96.5328239,786.503578 93.3091629,786.50287 91.3274702,788.497586 C91.3272944,788.497798 91.3270131,788.498046 91.3268022,788.498258 C91.3265561,788.498542 91.3262045,788.49886 91.3259233,788.499144 L91.0010084,788.826398 L90.6760583,788.499144 C89.7161495,787.532394 88.4398336,787 87.0823065,787 C85.7247443,787 84.4484987,787.532429 83.4885547,788.499144 C82.5286459,789.465893 82,790.751223 82,792.118374 C82,793.485561 82.5286459,794.770855 83.4885899,795.73764 L90.4868468,802.785513 C90.6232534,802.922887 90.808211,803 91.0010787,803 C91.1939464,803 91.3789039,802.922851 91.5152753,802.785513 L98.5133565,795.737782 C100.494487,793.743455 100.495647,790.498002 98.5162393,788.502011 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.745eb0f0.svg";
export { ForwardRef as ReactComponent };